import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  submissionStarted: false,
  partialCompletion: {
    status: null,
    jobId: null,
    fnolId: null,
  },
};

const fnolSubmissionSlice = createSlice({
  name: "fnolSubmission",
  initialState,
  reducers: {
    setSubmissionStarted(state, action) {
      state.submissionStarted = action.payload;
    },
    setPartialCompletion(state, action) {
      state.partialCompletion = action.payload;
    },
    resetSubmissionState(state) {
      return initialState;
    },
  },
});

// Actions
export const { setSubmissionStarted, setPartialCompletion, resetSubmissionState } = fnolSubmissionSlice.actions;

// Selectors
export const selectSubmissionStarted = (state) => state.fnolSubmission.submissionStarted;
export const selectPartialCompletion = (state) => state.fnolSubmission.partialCompletion;

export default fnolSubmissionSlice.reducer;
